import './permissons-roles-add-modal.tag'
riot.tag2('permissions-roles', '  <catalog object="PermissionRole" cols="{cols}" add="{add}" remove="{remove}" dblclick="{open}" reload="true" store="permissions-roles">\n    <yield to="body">\n      <datatable-cell name="name">{row.name}</datatable-cell>\n    </yield>\n  </catalog>\n', '', '', function(opts) {
'use strict';

var self = this;

self.mixin('remove');
self.collection = 'PermissionRole';

self.add = function () {
    modals.create('permissons-roles-add-modal', {
        type: 'modal-primary',
        submit: function submit() {
            var _this = this;
            _this.error = _this.validation.validate(_this.item, _this.rules);

            if (!_this.error) {
                API.request({
                    object: 'PermissionRole',
                    method: 'Save',
                    data: { name: this.name.value },
                    success: function success(response) {
                        popups.create({ title: 'Успех!', text: 'Роль добавлен!', style: 'popup-success' });
                        observable.trigger('permissions-roles-reload');
                        _this.modalHide();
                    }
                });
            }
        }
    });
};

observable.on('permissions-roles-reload', function () {
    return self.tags.catalog.reload();
});

self.open = function (e) {
    return riot.route('/settings/permissions/' + e.item.row.id);
};

self.cols = [{ name: "name", value: "Наименование" }];
});


// WEBPACK FOOTER //
// ./pages/settings/permissions/permissions-roles.tag